import { Link } from "react-router-dom";
import { footerColumns, site } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 border-b border-background-50/15 pb-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-emotion-happy-fill text-xl text-background-50" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl font-bold text-background-50">{site.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">{site.intro}</p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-200">
              <i className="ri-mail-line text-primary-300" aria-hidden="true"></i>
              <a href={`mailto:${site.email}`} className="hover:text-background-50">
                {site.email}
              </a>
            </p>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-base font-bold text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200 transition-colors hover:text-primary-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {site.name} · {site.icp}</p>
          <p className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="hover:text-primary-200">关于我们</Link>
            <Link to="/contact" className="hover:text-primary-200">联系我们</Link>
            <a href="#top" className="hover:text-primary-200">回到顶部</a>
          </p>
        </div>
      </div>
    </footer>
  );
}